'use client';

import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';

export function SessionDebugger() {
  const { data: session, status } = useSession();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show debug panel for 10 seconds after session change
    setIsVisible(true);
    const timer = setTimeout(() => setIsVisible(false), 10000);
    return () => clearTimeout(timer);
  }, [session, status]);

  if (process.env.NODE_ENV !== 'development' || !isVisible) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 rounded-lg bg-blue-900/90 p-4 text-white max-w-sm">
      <div className="text-xs">
        <div className="font-bold mb-2">Session Debug</div>
        <div>Status: <span className={status === 'authenticated' ? 'text-green-300' : status === 'unauthenticated' ? 'text-red-300' : 'text-yellow-300'}>{status}</span></div>
        <div>User: {session?.user?.email || 'None'}</div>
        <div>Session ID: {session?.user?.id || 'None'}</div>
        <div>Token: {(session as any)?.accessToken ? '✅' : '❌'}</div>
        <button
          onClick={() => setIsVisible(false)}
          className="mt-2 text-xs bg-blue-700 px-2 py-1 rounded hover:bg-blue-600"
        >
          Hide
        </button>
      </div>
    </div>
  );
}